import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { SimpleLoading } from '~/components';

import App from './App';

const rootEl = document.getElementById('root');
const root = createRoot(rootEl);

root.render(
  <BrowserRouter>
    <Suspense fallback={ <SimpleLoading size="lg" /> }>
      <App />
    </Suspense>
  </BrowserRouter>,
);
